import { useEffect, useMemo, useState } from "react";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { BtnGroupWAStyle, ContentStyle, RxTabsStyle } from "../../Theme";
import DeleteIcon from "../../images/icons/DeleteIcon.svg";
import { DialogPopup } from "../../components/DialogPopup";
import { YSButton } from "../../uikit/YSButton";
import { useLocation, useNavigate } from "react-router";
import YSSnackBar from "../../uikit/YSSnackBar";
import FreeTextForm from "./FreeTextForm";
import FreeTextMedicationPrescriptionSummary from "./FreeTextMedicationPrescriptionSummary";
import { HelpGuideTooltip } from "../../components/HelpGuideTooltip";
import { useDispatch, useSelector } from "react-redux";
import {
  freeTextAddNew,
  freeTextConfirm,
  freeTextInitialize,
} from "../../Apis/FreeTextApis";
import TabsNav from "../../components/TabsNav";
import { DrugPopulate } from "../../Apis/AuthApiServices";
import { loadingPharmacyDropDown } from "../../Redux/Slice/PharmacyDropDownSlice";
import { disableClinic } from "../../Redux/Slice/ClinicDisableSlice";

export default function FreeTextMedicationSingle() {
  const UserServiceState = useSelector((state: any) => {
    return { ...state?.UserServicesSlice?.ServicesData };
  }); //redux data
  const AllDropdwonsState = useSelector((state: any) => {
    return { ...state?.GlobalDropdownSlice?.DropdownLists };
  }); //redux data
  const { state }: any = useLocation();
  const dispatch = useDispatch();
  const [selectedTab, setSelectedTab] = useState("Rx 1");
  const [stateData, setStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  //const [tabIndex, setTabIndex] = useState<number>(1);
  const navigate = useNavigate();
  const [deleteDataPopup, setDeleteDataPopup] = useState(false);
  const [deteteRxData, setdeleteRxdata] = useState("");
  const [tabValue, setTabValue] = useState(1);
  const rxTabsData: any =
    sessionStorage.getItem("freeTextRxTabs") !== "undefined" ||
    sessionStorage.getItem("freeTextRxTabs") !== null
      ? JSON.parse(sessionStorage.getItem("freeTextRxTabs")!)
      : null;
  const [tabList, setTabList] = useState<any>([]);
  const memoData = useMemo(() => {
    return tabList?.map((item: any) => item);
  }, [tabList]);

  const handleShowDeletePopupClick = () => {
    setDeleteDataPopup(true);
  };
  const handleHideDeletePopupClick = () => {
    setDeleteDataPopup(false);
  };

  const getLabels = (values: any) => {
    let timelabels = "";
    if (values.sigTimeMorning === "ON")
      timelabels = timelabels + " at morning ";
    if (values.sigTimeNight === "ON") timelabels = timelabels + " at night";
    if (values.sigTimeAfterMeals === "ON")
      timelabels = timelabels + " at after meals";
    if (values.sigTimeBedTime === "ON") timelabels = timelabels + " at bedtime";
    if (values.sigTimeNoon === "ON") timelabels = timelabels + " at noon";
    if (values.sigTimeBeforeBed === "ON")
      timelabels = timelabels + " at before bed";
    if (values.sigTimeBeforeMeals === "ON")
      timelabels = timelabels + " at before meals";
    if (values.sigTimeEvening === "ON") timelabels = timelabels + " at evening";
    let currentDelivery = AllDropdwonsState?.sigDeliveryOptions?.find(
      (each: any) => each?.qualifierValue == values.sigDeliveryId
    );
    let currentDose = AllDropdwonsState?.sigDoseOptions?.find(
      (each: any) => each?.name == values.sigDoseId
    );
    let currentUnits = AllDropdwonsState?.sigDoseUnitsOptions?.find(
      (each: any) => each?.qualifierValue == values.sigDoseUnitsId
    );
    let currentFreq = AllDropdwonsState?.sigFreqOptions?.find(
      (each: any) => each?.qualifierValue == values.sigFreqId
    );

    return `${currentDelivery?.name ?? ""} ${currentDose?.name ?? ""} ${
      currentUnits?.name ?? ""
    } ${currentFreq?.name ?? ""} ${timelabels}`;
  };

  const newPrescription = async (values: any, validation: any) => {
    try {
      //setTabList([...tabList, values]);
      if (
        values.sig === "" ||
        values.sigFrqId ||
        values.sigDeliveryId ||
        values.sigDoseId ||
        values.sigDoseUnitsId
      ) {
        values.sig = getLabels(values);
      }
      values.sig = values.sig.trim();
      setLoading(true);
      const bodyData = {
        prescriptionForm: values ?? [],
        patientId: patientId,
        userDetails: {
          doctorId: doctorId,
          userId: localStorage.getItem("LoginUserID"),
          onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
      };
      const result: any = await freeTextAddNew(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        setLoading(false);
        if (result?.data?.response[0]?.prescriptionErrors?.length >= 1) {
          sessionStorage.setItem(
            "freeTextRxTabsErrors",
            JSON.stringify(result?.data?.response[0]?.prescriptionErrors)
          );
          tabList.pop();
          sessionStorage.setItem(
            "freeTextRxTabs",
            JSON.stringify([...tabList, values])
          );
          setTabList([...tabList, values]);
          setStateData((prevState: any) => {
            return {
              ...prevState,
              message: result?.data?.response[0]?.prescriptionErrors?.map(
                (each: any) => {
                  return (
                    <Box>
                      <Typography
                        component={"div"}
                        fontWeight={600}
                        variant={"body2"}
                      >
                        <strong> Rx-{each?.rxNumber}</strong>
                      </Typography>
                      {each?.errors?.map((ech: any) => {
                        return (
                          <Typography
                            component={"div"}
                            fontWeight={600}
                            variant={"body2"}
                            paddingLeft={2}
                          >
                            {" - "} {ech?.errorMessage}
                          </Typography>
                        );
                      })}
                    </Box>
                  );
                }
              ),
              variant: "error",
              open: true,
            };
          });
        } else {
          const errorPads =
            sessionStorage.getItem("freeTextRxTabsErrors") != undefined ||
            sessionStorage.getItem("freeTextRxTabsErrors") != null
              ? JSON.parse(sessionStorage.getItem("freeTextRxTabsErrors")!)
              : null;
          const removeErrorPad = errorPads?.filter(
            (t: any) => t?.rxNumber !== values.rxNumber
          );
          if (removeErrorPad == undefined || removeErrorPad == null) {
            sessionStorage.setItem("freeTextRxTabsErrors", JSON.stringify([]));
          } else {
            sessionStorage.setItem(
              "freeTextRxTabsErrors",
              JSON.stringify(removeErrorPad)
            );
          }

          addNewTab(result?.data?.response[0]?.prescriptionForm, values);
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    } catch (eror) {
      setLoading(false);
    }
  };
  const saveAndContinue = async (values: any, validation: any) => {
    try {
      setLoading(true);
      let prescriptionForm = values || {};
      const currentTab = parseInt(
        JSON.parse(sessionStorage.getItem("TabValue")!)
      );
      const forms: [] =
        sessionStorage.getItem("freeTextRxTabs") !== "undefined" ||
        sessionStorage.getItem("freeTextRxTabs") !== null
          ? JSON.parse(sessionStorage.getItem("freeTextRxTabs")!)
          : [];
      if (
        values.sig === "" ||
        values.sigFrqId ||
        values.sigDeliveryId ||
        values.sigDoseId ||
        values.sigDoseUnitsId
      ) {
        values.sig = getLabels(values);
      }
      values.sig = values.sig.trim();
      const bodyData = {
        prescriptionForm: values ?? [],
        patientId: patientId,
        userDetails: {
          doctorId: doctorId,
          userId: localStorage.getItem("LoginUserID"),
          onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
      };
      const updatedForm = forms.map((form: any) => {
        if (form.rxNumber == currentTab) {
          return (form = values);
        } else {
          return form;
        }
      });
      sessionStorage.setItem("freeTextRxTabs", JSON.stringify(updatedForm));
      const result: any = await freeTextAddNew(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        if (result?.data?.response[0]?.prescriptionErrors?.length >= 1) {
          sessionStorage.setItem(
            "freeTextRxTabsErrors",
            JSON.stringify(result?.data?.response[0]?.prescriptionErrors)
          );
          setStateData((prevState: any) => {
            return {
              ...prevState,
              message: result?.data?.response[0]?.prescriptionErrors?.map(
                (each: any) => {
                  return (
                    <Box>
                      <Typography
                        component={"div"}
                        fontWeight={600}
                        variant={"body2"}
                      >
                        <strong> Rx-{each?.rxNumber}</strong>
                      </Typography>
                      {each?.errors?.map((ech: any) => {
                        return (
                          <Typography
                            component={"div"}
                            fontWeight={600}
                            variant={"body2"}
                            paddingLeft={2}
                          >
                            {" - "} {ech?.errorMessage}
                          </Typography>
                        );
                      })}
                    </Box>
                  );
                }
              ),
              variant: "error",
              open: true,
            };
          });
          setSelectedTab(
            `Rx ${result?.data?.response[0]?.prescriptionErrors[0].rxNumber}`
          );
          setLoading(false);
        } else {
          const errorPads =
            sessionStorage.getItem("freeTextRxTabsErrors") != "undefined" ||
            sessionStorage.getItem("freeTextRxTabsErrors") !== null
              ? JSON.parse(sessionStorage.getItem("freeTextRxTabsErrors")!)
              : null;
          if (errorPads != null) {
            const removeErrorPad = errorPads?.filter(
              (t: any) => t?.rxNumber !== values.rxNumber
            );
            sessionStorage.setItem(
              "freeTextRxTabsErrors",
              JSON.stringify(removeErrorPad)
            );
          }

          setSelectedTab(`Rx ${currentTab + 1}`);
          sessionStorage.setItem(
            "TabValue",
            JSON.stringify((currentTab + 1)?.toString())
          );
          setTabValue(currentTab + 1);
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
    }
  };
  const addNewTab = (resultData: any, preValues: any) => {
    const value = `Rx ${tabList.length + 1}`;
    let prescriptionForm = resultData || {};

    prescriptionForm.rxNumber = tabList.length + 1;
    //setTabList([...tabList, prescriptionForm]);
    tabList.pop();
    sessionStorage.setItem(
      "freeTextRxTabs",
      JSON.stringify([...tabList, preValues, prescriptionForm])
    );
    setTabList([...tabList, preValues, prescriptionForm]);
    //sessionStorage.setItem("rxTabs", JSON.stringify(tabList));
    setSelectedTab(value);
    sessionStorage.setItem("TabValue", JSON.stringify(value.split(" ")[1]));
    //setTabIndex(tabIndex + 1);
    setTabValue(tabValue + 1);

    // setTabValue((prevValue: any) => prevValue + 1);
  };
  const handleClose = (event: any, value: any) => {
    event.stopPropagation();
    const tabArr = tabList
      ?.filter((t: any) => t?.rxNumber !== value)
      .map((each: any, index: any) => {
        each.rxNumber = index + 1;
        return each;
      });
    //setTabList(tabArr);
    setSelectedTab(`Rx ${value - 1}`);
    sessionStorage.setItem("TabValue", JSON.stringify(value - 1));

    setTabValue((prevValue: any) => prevValue - 1);
    sessionStorage.setItem("freeTextRxTabs", JSON.stringify(tabArr));
    setTabList(tabArr);
    //let total = JSON.parse(sessionStorage.getItem("locationData")!);
    //total.prescriptionFormList = tabArr;
    // let new = Total?.prescriptionFormList
    // new = tabArr
    //sessionStorage.setItem("locationData", JSON.stringify(total));
    //sessionStorage.removeItem(`RX-${value.split(" ")[1]}`);
    //setTabIndex(tabIndex - 1);
  };

  const handleChange = (event: any, newValue: any) => {
    if (newValue === "summary") {
      navigate("/freetextmedication/summary");
    } else {
      navigate("/freetextmedication");
    }
    setSelectedTab(newValue);
    sessionStorage.setItem("TabValue", JSON.stringify(newValue.split(" ")[1]));
    //setTabIndex(newValue === "Rx 1" ? 1 : newValue.split(" ")[1]);
  };

  const [submitLoad, setSubmitLoad] = useState(false);
  const submitAllForms = async (values: any) => {
    try {
      const forms: [] =
        sessionStorage.getItem("freeTextRxTabs") !== "undefined" ||
        sessionStorage.getItem("freeTextRxTabs") !== null
          ? JSON.parse(sessionStorage.getItem("freeTextRxTabs")!)
          : [];
      setSubmitLoad(true);
      if (
        values.sig === "" ||
        values.sigFrqId ||
        values.sigDeliveryId ||
        values.sigDoseId ||
        values.sigDoseUnitsId
      ) {
        values.sig = getLabels(values);
      }
      values.sig = values.sig.trim();
      // tabList.pop();
      // sessionStorage.setItem("rxTabs", JSON.stringify([...tabList, values]));
      const updatedForm = forms.map((form: any) => {
        if (form.rxNumber == values.rxNumber) {
          return (form = values);
        } else {
          return form;
        }
      });
      sessionStorage.setItem("freeTextRxTabs", JSON.stringify(updatedForm));
      setTabList(updatedForm);
      setTimeout(async () => {
        const bodyData = {
          prescriptionFormList:
            sessionStorage.getItem("freeTextRxTabs") !== "undefined" ||
            sessionStorage.getItem("freeTextRxTabs") !== null
              ? JSON.parse(sessionStorage.getItem("freeTextRxTabs")!)
              : [],
          patientId: patientId,
          userDetails: {
            doctorId:
              UserServiceState?.profileGroup > 6
                ? localStorage.getItem("SupervisorDoctorId")
                : localStorage.getItem("doctorId"),
            onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
            selectedClinicId: sessionStorage.getItem("clinicId"),
          },
        };
        const result: any = await freeTextConfirm(bodyData);
        if (result?.data?.digitalRxStatusCode === 200) {
          if (
            result?.data?.response[0]?.prescriptionErrors != null &&
            result?.data?.response[0]?.prescriptionErrors?.length >= 1
          ) {
            sessionStorage.setItem(
              "freeTextRxTabsErrors",
              JSON.stringify(result?.data?.response[0]?.prescriptionErrors)
            );

            setStateData((prevState: any) => {
              return {
                ...prevState,
                message: result?.data?.response[0]?.prescriptionErrors?.map(
                  (each: any) => {
                    return (
                      <Box>
                        <Typography
                          component={"div"}
                          fontWeight={600}
                          variant={"body2"}
                        >
                          <strong> Rx-{each?.rxNumber}</strong>
                        </Typography>
                        {each?.errors?.map((ech: any) => {
                          return (
                            <Typography
                              component={"div"}
                              fontWeight={600}
                              variant={"body2"}
                              paddingLeft={2}
                            >
                              {" - "} {ech?.errorMessage}
                            </Typography>
                          );
                        })}
                      </Box>
                    );
                  }
                ),

                variant: "error",
                open: true,
              };
            });
            setSelectedTab(
              `Rx ${result?.data?.response[0]?.prescriptionErrors[0].rxNumber}`
            );
            sessionStorage.setItem(
              "TabValue",
              JSON.stringify(
                result?.data?.response[0]?.prescriptionErrors[0].rxNumber?.toString()
              )
            );
            setSubmitLoad(false);
          } else {
            sessionStorage.removeItem("freeTextRxTabsErrors");
            sessionStorage.setItem(
              "locationData",
              JSON.stringify(result?.data?.response[0])
            );
            setSelectedTab("summary");
            navigate("/freetextmedication/summary");
            setSubmitLoad(false);
          }
          // sessionStorage.setItem(
          //   "rxTabs",
          //   JSON.stringify(result.data?.response[0]?.prescriptionFormList)
          // );
          setSubmitLoad(false);
        } else {
          setStateData((prevState: any) => {
            return {
              ...prevState,
              message: result?.data?.digitalRxStatusMessage,
              variant: "error",
              open: true,
            };
          });
          setSubmitLoad(false);
        }
      }, 2000);
    } catch (error) {
      setStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try again after some time!",
          variant: "error",
          open: true,
        };
      });
      setSubmitLoad(false);
    }
  };

  const resetRxForm = async (values: any) => {
    const resTemplate = await getInitializeRxpad(true);
    const currentTabs =
      sessionStorage.getItem("freeTextRxTabs") !== "undefined" ||
      sessionStorage.getItem("freeTextRxTabs") !== null
        ? JSON.parse(sessionStorage.getItem("freeTextRxTabs")!)
        : null;
    const updatedForm = currentTabs?.map((form: any) => {
      if (form.rxNumber === values.rxNumber) {
        resTemplate.rxNumber = form.rxNumber;
        return (form = resTemplate);
      } else {
        return form;
      }
    });
    sessionStorage.setItem("freeTextRxTabs", JSON.stringify(updatedForm));
    const currentErrors =
      sessionStorage.getItem("freeTextRxTabsErrors") !== "undefined" ||
      sessionStorage.getItem("freeTextRxTabsErrors") !== null
        ? JSON.parse(sessionStorage.getItem("freeTextRxTabsErrors")!)
        : null;
    if (currentErrors != null) {
      const removeErrorPad = currentErrors?.filter(
        (t: any) => t?.rxNumber !== values.rxNumber
      );
      sessionStorage.setItem(
        "freeTextRxTabsErrors",
        JSON.stringify(removeErrorPad)
      );
    }
    setTabList(updatedForm);
  };

  const [loading, setLoading] = useState(false);
  // const [Message, setMessage] = useState("");
  const doctorId: any = localStorage.getItem("doctorId");
  const patientId: any = sessionStorage.getItem("patientId");
  const getInitializeRxpad = async (needRes: Boolean = false) => {
    try {
      setLoading(true);
      sessionStorage.removeItem("locationData");
      const bodyData = {
        patientId: patientId,
        userDetails: {
          userId: localStorage.getItem("LoginUserID"),
          doctorId: doctorId,
          onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
      };
      const result = await freeTextInitialize(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        if (needRes) {
          // setMessage("");

          setLoading(false);
          return result?.data?.response[0]?.prescriptionForm;
        } else {
          // setMessage("");

          setTabList([result?.data?.response[0]?.prescriptionForm]);
          setSelectedTab(
            `Rx ${result?.data?.response[0]?.prescriptionForm?.rxNumber}`
          );
          sessionStorage.setItem(
            "freeTextRxTabs",
            JSON.stringify([result?.data?.response[0]?.prescriptionForm])
          );
          sessionStorage.setItem(
            "freeTextRxTabsErrors",
            JSON.stringify(result?.data?.response[0]?.prescriptionErrors)
          );
          sessionStorage.setItem("TabValue", JSON.stringify("1"));
          dispatch(disableClinic());
          // localStorage.setItem(
          //   "rxHubOptions",
          //   JSON.stringify(
          //     result?.data?.response[0]?.prescriptionForm
          //       ?.rxhubPBMUniqueIdOptions
          //   )
          // );
          // localStorage.setItem(
          //   "rxhubPBMUniqueId",
          //   result?.data?.response[0]?.prescriptionForm?.rxhubPBMUniqueId
          // );
        }
        setLoading(false);
        // setMessage("");
      } else {
        // setMessage(result?.data?.digitalRxStatusMessage);
        setTabList([{ rxNumber: 1 }]);
        setLoading(false);
      }
    } catch (error) {
      setTabList([{ rxNumber: 1 }]);
      setLoading(false);
      // setMessage("");
    }
  };
  const getPopulateData = async (props?: any) => {
    try {
      const tabValue =
        JSON.parse(sessionStorage.getItem("TabValue") ?? "1") - 1;
      setLoading(true);
      var bodyData: any = {
        prescriptionForm: {
          medicationHistoryId:
            state?.key === "FreeTextMHPop" ? state?.rowData?.personDrugId : "",
          favoriteDrugId:
            state?.key === "FreeTextFavDrugPop"
              ? state?.rowData?.personDrugId
              : "",
          prescriptionType: "freetextrx",
          drugId: state?.rowData?.drugId,
          initQtyQualifierListFlag: "false",
          rxNumber: JSON.parse(sessionStorage.getItem("TabValue")!) ?? 1,
        },
        patientId: patientId,
        userDetails: {
          userId: "",
          doctorId:
            UserServiceState?.profileGroup > 6
              ? localStorage.getItem("SupervisorDoctorId")
              : localStorage.getItem("doctorId"),
          onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
      };

      const result = await DrugPopulate(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        let tabs = JSON.parse(sessionStorage.getItem("freeTextRxTabs") ?? "[]");
        tabs[tabValue] = result?.data?.response[0]?.prescriptionForm;
        sessionStorage.setItem("freeTextRxTabs", JSON.stringify(tabs));
        setTabList(tabs);
        setSelectedTab(`Rx ${tabValue + 1}`);
        setLoading(false);
      } else {
        setLoading(false);
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
        setSelectedTab(`Rx ${tabValue + 1}`);
      }
    } catch (er) {
      setLoading(false);
      setSelectedTab(`Rx ${tabValue + 1}`);
    }
  };

  const callSequenceCall = async () => {
    await getInitializeRxpad();
    await getPopulateData();
    await dispatch(loadingPharmacyDropDown());
  };

  const drugPopulateToFreeText = async () => {
    await getPopulateData();
    await dispatch(loadingPharmacyDropDown());
  };
  useEffect(() => {
    sessionStorage.removeItem("rxTabs");
    sessionStorage.removeItem("rxTabsErrors");
    if (
      !sessionStorage.getItem("freeTextRxTabs") &&
      tabValue === 1 &&
      state?.key !== "FreeTextMHPop" &&
      state?.key !== "FreeTextFavDrugPop"
    ) {
      getInitializeRxpad();
    } else if (
      state?.key === "FreeTextMHPop" ||
      state?.key === "FreeTextFavDrugPop"
    ) {
      if (!sessionStorage.getItem("freeTextRxTabs")) {
        callSequenceCall();
      } else {
        drugPopulateToFreeText();
      }
    } else {
      sessionStorage.setItem("TabValue", JSON.stringify("1"));
    }
  }, [
    UserServiceState?.allowedToPrint &&
      UserServiceState?.allowedToPrintControlledSubstances,
  ]);

  useEffect(() => {
    if (rxTabsData) {
      setTabList(
        sessionStorage.getItem("freeTextRxTabs") !== "undefined" ||
          sessionStorage.getItem("freeTextRxTabs") !== null
          ? JSON.parse(sessionStorage.getItem("freeTextRxTabs")!)
          : []
      );
    }
    if (!sessionStorage.getItem("TabValue")) {
      sessionStorage.setItem("TabValue", JSON.stringify("1"));
    }
  }, []);
  useEffect(() => {
    if (
      state === "confirmFreeTextMhList" ||
      state === "confirmFreeTextFdList"
    ) {
      setSelectedTab("summary");
      dispatch(loadingPharmacyDropDown());
    }
  }, [state]);
  return (
    <>
      {loading ? (
        <Box
          style={{
            width: "100%",
            height: 200,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            variant="body1"
            color={"primary"}
            component="div"
            fontWeight={500}
          >
            Please wait while we fetch the patient's history!
          </Typography>
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <>
          <TabsNav />
          <ContentStyle>
            <Typography
              className="help"
              component="h6"
              color="primary"
              variant="h6"
            >
              Free Text Medication
              <HelpGuideTooltip
                content={
                  <>
                    <Typography component="div" variant="body1">
                      Prescriptions that doctors write and save for potential
                      future use, regardless of the patients.
                    </Typography>
                  </>
                }
              />
            </Typography>
            {/* {!UserServiceState?.allowedToPrint ||
              (!UserServiceState?.allowedToPrintControlledSubstances && (
                <Typography variant="body1" color="error">
                  As per state regulatory, All prescriptions must be sent
                  electronically only.
                </Typography>
              ))} */}
            {/* {Message && (
              <Typography variant="body1" color="error">
                {Message}
              </Typography>
            )} */}
            <TabContext value={selectedTab}>
              <Grid
                container
                xs={12}
                spacing={0}
                alignItems="center"
                justifyContent="flex-start"
              >
                <Grid item xs={12}>
                  <RxTabsStyle>
                    <Box style={{ display: "flex" }}>
                      <TabList
                        variant="scrollable"
                        scrollButtons="auto"
                        onChange={handleChange}
                        className={"tablist"}
                      >
                        {memoData?.map((tab: any) => (
                          <Tab
                            key={tab?.rxNumber}
                            label={
                              <Tooltip
                                title={tab?.drugName}
                                placement="top"
                                arrow
                              >
                                <span>Rx {tab?.rxNumber}</span>
                              </Tooltip>
                            }
                            value={`Rx ${tab?.rxNumber}`}
                            iconPosition="end"
                            icon={
                              tab?.rxNumber !== 1 ? (
                                <IconButton
                                  color="error"
                                  className="remove"
                                  id={tab?.rxNumber}
                                  aria-label="close"
                                  onClick={() => {
                                    handleShowDeletePopupClick();
                                    setdeleteRxdata(tab?.rxNumber);
                                  }}
                                >
                                  <img
                                    src={DeleteIcon}
                                    alt="DeleteIcon"
                                    loading="lazy"
                                  />
                                </IconButton>
                              ) : (
                                ""
                              )
                            }
                          />
                        ))}
                      </TabList>
                      <YSButton
                        color="inherit"
                        children="Summary"
                        variant="outlined"
                        type="button"
                        disabled={
                          JSON.parse(sessionStorage.getItem("locationData")!)
                            ?.prescriptionFormList?.length ==
                          JSON.parse(
                            sessionStorage.getItem("freeTextRxTabs") ?? "[]"
                          )?.length
                            ? false
                            : true
                        }
                        onClick={() => {
                          navigate("/freetextmedication/summary");
                          setSelectedTab("summary");
                        }}
                        size="large"
                        className={
                          selectedTab === "summary"
                            ? "summary-btn active"
                            : "summary-btn"
                        }
                      />
                    </Box>
                  </RxTabsStyle>
                </Grid>
              </Grid>
              {memoData.map((panel: any, index: any) => (
                <TabPanel
                  key={panel?.rxNumber}
                  value={`Rx ${panel?.rxNumber}`}
                  style={{ padding: 0, width: "100%" }}
                >
                  <FreeTextForm
                    newPrescription={newPrescription}
                    saveAndContinue={saveAndContinue}
                    tabListLength={memoData?.length}
                    submitAllForms={submitAllForms}
                    submitLoad={submitLoad}
                    resetRxForm={resetRxForm}
                    panel={panel}
                    setTabList={setTabList}
                    // Message={Message}
                  />
                </TabPanel>
              ))}

              <TabPanel value={"summary"} style={{ padding: 0, width: "100%" }}>
                <FreeTextMedicationPrescriptionSummary
                  setSelectedTab={setSelectedTab}
                  getInitializeRxpad={getInitializeRxpad}
                  setTabList={setTabList}
                  // setTabValue={setTabValue}
                />
              </TabPanel>
            </TabContext>
          </ContentStyle>
        </>
      )}
      <DialogPopup
        windowsize={"sm"}
        show={deleteDataPopup}
        handleShowPopupClick={handleShowDeletePopupClick}
        handleHidePopupClick={handleHideDeletePopupClick}
        close={true}
      >
        <Grid container spacing={0}>
          <Grid item xs={12} textAlign="center" marginTop={6}>
            <Typography component={"div"} variant={"h6"} fontWeight={350}>
              {`Are you sure? Want to delete the ${deteteRxData}`}
            </Typography>
            <Grid
              item
              xs={12}
              textAlign="center"
              marginTop={5}
              className="btns"
            >
              <BtnGroupWAStyle>
                <YSButton
                  color="secondary"
                  children="Cancel"
                  variant="outlined"
                  type="button"
                  onClick={handleHideDeletePopupClick}
                  size="large"
                  className=""
                />{" "}
                <YSButton
                  children="Confirm"
                  variant="contained"
                  type="button"
                  onClick={(event) => {
                    handleHideDeletePopupClick();
                    handleClose(event, deteteRxData);
                  }}
                  size="large"
                  className=""
                />
              </BtnGroupWAStyle>
            </Grid>
          </Grid>
        </Grid>
      </DialogPopup>
      <YSSnackBar
        message={stateData.message}
        variant={stateData.variant}
        open={stateData.open}
        handleClose={() => {
          setStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
